<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_bi3"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('shipmentCompany_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('shipmentCompany_add_button')"
          @click="funcAdd"
        >
          新增
        </el-button>
        <el-button
          v-if="getLimit('shipmentCompany_checkQuire_button') && isAdmin"
          @click="funcheckQuire"
        >
          设置必填项
        </el-button>
        <!-- 邀请注册 -->
        <el-button @click="handleInviteRegister">
          邀请注册
        </el-button>
        <el-button
          v-if="getLimit('shipmentCompany_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      class="mytable-style"
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :cell-class-name="cellClassName"
      :show-footer="true"
      :footer-method="footerMethod"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authStatus"
          title="审核状态"
          :formatter="formatterAuthStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in authStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="companyName"
          title="企业名称"
          min-width="280"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入企业名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="businessLicenseImgNumber"
          title="统一社会信用代码"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.businessLicenseImgNumber"
            placeholder="请输入统一社会信用代码"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="userName"
          title="联系人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入联系人"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="联系方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入联系方式"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 平台服务经理 -->
      <vxe-table-column>
        <vxe-table-column
          field="salesmanName"
          title="平台服务经理"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.salesmanName"
            placeholder="请输入平台服务经理"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 平台服务经理号码 -->
      <vxe-table-column>
        <vxe-table-column
          field="salesmanPhone"
          title="平台服务经理号码"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.salesmanPhone"
            placeholder="请输入平台服务经理号码"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="idCardDueDate"
          title="身份证到期日期"
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.idCardDueRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'idCardDueDate')"
          />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column v-if="isCtms">
        <vxe-table-column
          field="taxPoint"
          title="服务费率(%)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPointStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPointEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->

      <vxe-table-column>
        <vxe-table-column
          field="cycle"
          title="账期(天)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.cycleStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.cycleEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="limitCount"
          title="额度(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.limitCountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.limitCountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column v-if="isCtms">
        <vxe-table-column
          field="taxPoint"
          title="服务费率(%)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPointStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPointEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="isMonthlyClient"
          :formatter="formatterCommonStatus"
          title="是否月结"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isMonthlyClient"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in commonStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isCtms">
        <vxe-table-column
          field="isIndependentCheckout"
          title="是否独立核算"
          :formatter="formatterCommonStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isIndependentCheckout"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in commonStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isCtms">
        <vxe-table-column
          field="ensureFee"
          title="保证金基准(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.ensureFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.ensureFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isCtms">
        <vxe-table-column
          field="ensureFeeAmount"
          title="保证金余额(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.ensureFeeAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.ensureFeeAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="alipayAccount"
          title="支付宝账号"
          :formatter="formatterAlipayAccount"
          min-width="230"
          sortable
        />
        <template v-slot:header />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authTime"
          title="审核时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtAuthRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'authTime')"
          />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" width="260" fixed="right">
        <template slot-scope="scope">
          <div class="shipment_op">
            <el-tooltip
              v-if="getLimit('shipmentCompany_detail_button')"
              class="item"
              effect="dark"
              content="详情"
              placement="top"
            >
              <vxe-button type="text" @click="funcDetail(scope.row)">
                <i class="el-icon-document" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="getLimit('shipmentCompany_edit_button')"
              class="item"
              effect="dark"
              content="编辑"
              placement="top"
            >
              <vxe-button type="text" @click="funcEdit(scope.row)">
                <i class="el-icon-edit" />
              </vxe-button>
            </el-tooltip>
            <!-- 预付开关       scope.row.isShow === 0-->
            <el-tooltip
              v-if="
                scope.row.authStatus === 3 &&
                  getLimit('shipmentCompany_yufu_button') &&
                  scope.row.isShow === 0
              "
              class="item"
              effect="dark"
              :content="
                `预付开关:${scope.row.isShow === 1 ? '已开启' : '已关闭'}`
              "
              placement="top"
            >
              <span class="shipment-switch">
                <!-- <img
                  v-if="scope.row.isShow === 1"
                  style="width:17px;height:19px;"
                  src="@/assets/icon/kai.png"
                  alt=""
                  @click="changeSwitchPre(scope.row)"
                /> -->
                <img
                  v-if="scope.row.isShow === 0"
                  style="width:17px;height:19px;"
                  src="@/assets/icon/guan.png"
                  alt=""
                  @click="changeSwitchPre(scope.row)"
                />
              </span>
            </el-tooltip>

            <!-- 回单付开关       -->
            <el-tooltip
              v-if="
                scope.row.authStatus === 3 &&
                  getLimit('shipmentCompany_huidanfu_button') &&
                  scope.row.isReturnPay === 0
              "
              class="item"
              effect="dark"
              :content="
                `回单付开关:${
                  scope.row.isReturnPay === 1 ? '已开启' : '已关闭'
                }`
              "
              placement="top"
            >
              <!-- v-if="scope.row.isReturnPay === 1" -->
              <span class="shipment-switch">
                <!-- <img
                  v-if="scope.row.isReturnPay === 1"
                  style="width:15px;height:17px;"
                  src="@/assets/icon/huidanfu_guan.png"
                  alt=""
                  @click="changeSwitchReturnPay(scope.row)"
                /> -->
                <img
                  v-if="scope.row.isReturnPay === 0"
                  style="width:15px;height:17px;"
                  src="@/assets/icon/huidanfu_guan.png"
                  alt=""
                  @click="changeSwitchReturnPay(scope.row)"
                />
              </span>
            </el-tooltip>
            <!-- 是否财务支付油费 -->
            <el-tooltip
              v-if="scope.row.authStatus === 3"
              class="item"
              effect="dark"
              :content="
                `是否财务支付油费:${
                  scope.row.isNeedFinancePay === 1 ? '已关闭' : '已开启'
                }`
              "
              placement="top"
            >
              <span class="shipment-switch">
                <img
                  v-if="scope.row.isNeedFinancePay === 0"
                  style="width:15px;height:17px;"
                  src="@/assets/icon/finance_pay_oil_on.png"
                  alt="财务支付油费已开启"
                  @click="changeSwitchNeedFinancePay(scope.row)"
                />
                <img
                  v-else
                  style="width:15px;height:17px;"
                  src="@/assets/icon/finance_pay_oil_off.png"
                  alt="财务支付油费已关闭"
                  @click="changeSwitchNeedFinancePay(scope.row)"
                />
              </span>
            </el-tooltip>
            <el-dropdown
              v-if="showShipmentMore(scope.row)"
              trigger="hover"
              placement="bottom"
            >
              <span class="shipment_more_trigger">
                更多<i class="el-icon-arrow-down" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="getLimit('shipmentCompany_delete_button')"
                >
                  <span @click="funcDelete(scope.row.code)">删除</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    getLimit('shipmentCompany_DIS_button') &&
                      showApplyDisBtn(scope.row)
                  "
                >
                  <span @click="funcApply(scope.row.partyCode)">申请DIS</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    scope.row.authStatus == 3 &&
                      !scope.row.memNum &&
                      getLimit('shipmentCompany_xvni_button')
                  "
                >
                  <span @click="funcDobiz(scope.row.code)">申请虚拟账号</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    scope.row.branchCode === 'lbb03' &&
                      getLimit('shipmentCompany_alipay_button') &&
                      !scope.row.alipayAccount
                  "
                >
                  <span @click="funAlipay(scope.row.code)">申请网商账号</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    scope.row.authStatus === 3 &&
                      getLimit('shipmentCompany_qiehuan_button')
                  "
                >
                  <span @click="showBranch(scope.row)">切换主体</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    scope.row.authStatus === 3 &&
                      getLimit('shipmentCompany_fenpei_button')
                  "
                >
                  <span @click="showQuota(scope.row)">分配额度</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="getLimit('shipmentCompany_replacemanager_button')"
                >
                  <span @click="handleManage(scope.row)">替换平台经理</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <el-tooltip
              class="item"
              effect="dark"
              content="子账号"
              placement="top"
            >
              <vxe-button type="text" @click="applySubAccount(scope.row)">
                <i class="el-icon-connection" />
              </vxe-button>
            </el-tooltip> -->
            <!-- 创建子账号 -->
            <!-- 设置为母公司 -->
            <!-- <el-tooltip
              v-if="
                getLimit('shipmentCompany_replacemanager_button') &&
                  scope.row.isSubPermission == 0
              "
              class="item"
              effect="dark"
              content="设置为母公司"
              placement="top"
            >
              <vxe-button type="text" @click="handleTotalCompany(scope.row)">
                <img
                  style="width:17px;height:17px;display:inline-block;"
                  src="@/assets/icon/zi.png"
                />
              </vxe-button>
            </el-tooltip> -->
          </div>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
    <!-- 切换主体 -->
    <vxe-modal
      v-if="showBranchModel"
      v-model="showBranchModel"
      title="切换主体"
      width="500"
      height="400"
      resize
    >
      <selectBranch
        :branch-info="branchInfo"
        @cancelModel="showBranchModel = false"
        @updateList="updateList"
      />
    </vxe-modal>
    <!-- 分配额度 -->
    <vxe-modal
      v-if="showQuotaModel"
      v-model="showQuotaModel"
      title="分配额度"
      width="500"
      height="300"
      resize
    >
      <allocateQuota
        :info="quotaInfo"
        @cancelModel="showQuotaModel = false"
        @updateList="updateList"
      />
    </vxe-modal>
    <!-- 替换平台经理 -->
    <vxe-modal
      v-if="showManage"
      v-model="showManage"
      title="替换平台经理"
      width="500"
      height="300"
      resize
    >
      <replaceManager
        :info="mangerInfo"
        @cancelModel="showManage = false"
        @updateList="updateList"
      />
    </vxe-modal>
    <!-- 邀请注册 -->
    <vxe-modal
      v-if="showInviteModel"
      v-model="showInviteModel"
      title="邀请注册"
      width="520"
      height="480"
      resize
    >
      <inviteRegister @cancelModel="showInviteModel = false" />
    </vxe-modal>
  </div>
</template>
<script>
// import selectBranch from "./components/selectBranch.vue";
import selectBranch from "../shipmentRate/components/selectBranch.vue";
import { getRole } from "@/utils/getRole";
import allocateQuota from "./components/allocateQuota.vue";
import replaceManager from "./components/replaceManager.vue";
import inviteRegister from "./components/inviteRegister.vue";
import {
  getShipperList,
  delShipperInfo,
  maYiBlockChain,
  syncMemName,
  syncFreightSubaccount,
  updateShowStatus,
  updateReturnPayStatus,
  updateNeedFinancePay,
  updateCompanyStatus,
  createFreightSubaccount
} from "@/api/shipment";
import selectBranchVue from "../shipmentRate/components/selectBranch.vue";
export default {
  name: "ShipmentCompanyList",
  components: {
    selectBranch,
    allocateQuota,
    replaceManager,
    inviteRegister
  },
  data() {
    return {
      showQuotaModel: false,
      showManage: false,
      showInviteModel: false,
      quotaInfo: {},
      mangerInfo: {},
      exportObj: {
        exportUrl: "/ntocc-basic-api/shipment/exportShipment", //导出接口
        name: "企业托运人"
      },
      isCtms: true, //默认显示 同城系统时隐藏
      branch: this.$store.getters.branch,
      loading: false,
      tableData: [],
      listQuery: {
        gmtCreatedRange: "",
        idCardDueRange: "",
        gmtAuthRange: "",
        staffType: "1", // 类型(企业)
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        exportType: 1,
        subType: 2
      },
      sumObject: {
        freezingAmount: 0,
        amount: 0,
        ensureFeeAmount: 0
      },
      // 审核状态
      authStatusList: [
        { label: "未审核", value: 0 },
        // { label: "审核中", value: 1 },
        { label: "审核驳回", value: 2 },
        { label: "审核通过", value: 3 }
      ],
      // 通用是否状态
      commonStatusList: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 是否admin
      isAdmin: false,
      branchInfo: null,
      showBranchModel: false
      // 是否顶级机构
      // isTopBranch: false,
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    },
    "$store.state.tagsView.cachedViews": function(cachedViews) {
      // 新增调回需要刷新数据
      if (!cachedViews.includes("ShipmentCompanyManage")) {
        let route = this.getRoute(this.$router.options.routes);
        route.meta.keepLive = false;
      }
    },
    "$route.query.needRefreshCompany": function(newVal, oldVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.RefreshList();
          let newQuery = JSON.parse(JSON.stringify(this.$route.query));
          delete newQuery.needRefreshCompany;
          this.$router.replace({ query: newQuery });
        });
      }
    }
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.findList();
    this.isCtmsShow = getRole(); //获取登录用户登录的是否是同城系统
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    this.platformDid = dataBranch.platformDid;
    if (
      dataBranch.partyGroupConfigCacheMap.MaYiBlockChainConfig_useMaYiBlockChain
    ) {
      this.openMaYiBlockChain =
        dataBranch.partyGroupConfigCacheMap
          .MaYiBlockChainConfig_useMaYiBlockChain.configValue == 1
          ? true
          : false;
    }
    // this.isTopBranch = dataBranch.level == 0;
  },
  methods: {
    applySubAccount(row) {
      const now = new Date();
      const pad = num => (num < 10 ? "0" + num : num);
      const outTradeNo = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
        now.getDate()
      )}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
      const data = {
        outUserId: "2266" + row.code,
        outUserName: row.companyName,
        outTradeNo: outTradeNo,
        ownerName: row.legalName,
        ownerCardNo: "510521198610283155",
        ownerCardType: "RESIDENT_ID_CARD"
      };
      createFreightSubaccount(data);
    },
    handleInviteRegister() {
      this.showInviteModel = true;
    },
    handleTotalCompany(info) {
      this.$confirm("确认设置为母公司吗？")
        .then(_ => {
          updateCompanyStatus({
            code: info.code,
            isSubPermission: 1
          }).then(response => {
            if (response.status == 0) {
              this.$message({ message: response.msg, type: "success" });
              this.findList();
            }
          });
        })
        .catch(_ => {});
    },
    // 替换平台经理
    handleManage(info) {
      this.mangerInfo = info;
      this.showManage = true;
    },
    changeSwitchPre(item) {
      this.$confirm(
        `确认${item.isShow == 1 ? "关闭" : "开启"}预付吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        updateShowStatus({
          code: item.code,
          isShow: item.isShow == 1 ? 0 : 1
        }).then(response => {
          if (response.status == 0) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            item.isShow = item.isShow == 1 ? 0 : 1;
            this.findList();
          }
        });
      });
    },
    changeSwitchReturnPay(item) {
      this.$confirm(
        `确认${item.isReturnPay == 1 ? "关闭" : "开启"}回单付吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        updateReturnPayStatus({
          code: item.code,
          isReturnPay: item.isReturnPay == 1 ? 0 : 1
        }).then(response => {
          if (response.status == 0) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            item.isReturnPay = item.isReturnPay == 1 ? 0 : 1;
            this.findList();
          }
        });
      });
    },
    changeSwitchNeedFinancePay(item) {
      const isOn = item.isNeedFinancePay === 0;
      this.$confirm(`确认${isOn ? "关闭" : "开启"}财务支付油费吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        updateNeedFinancePay({
          code: item.code,
          isNeedFinancePay: isOn ? 1 : 0
        }).then(response => {
          if (response.status == 0) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            item.isNeedFinancePay = isOn ? 1 : 0;
            this.findList();
          }
        });
      });
    },
    // 分配额度
    showQuota(info) {
      this.quotaInfo = info;
      this.showQuotaModel = true;
    },
    updateList() {
      this.showBranchModel = false;
      this.showManage = false;
      this.findList();
    },
    showBranch(info) {
      this.branchInfo = info;
      this.showBranchModel = true;
    },
    getRoute(routerList) {
      var list = "";
      for (let item of routerList) {
        if (item.children) {
          let clist = this.getRoute(item.children);
          if (this.getRoute(item.children)) {
            return clist;
          }
        }
        if (item.name == "ShipmentCompanyManage") {
          list = item;
          return list;
        }
      }
      return list;
    },
    showApplyDisBtn(row) {
      if (!this.openMaYiBlockChain || this.isCtmsShow) {
        return false;
      }
      let hasDid = !(
        typeof this.platformDid == "undefined" || this.platformDid == ""
      );
      return (
        hasDid &&
        row.authStatus == 3 &&
        (row.szwlDid == null || row.szwlDid == "")
      );
    },
    findList() {
      return new Promise(resolve => {
        this.loading = true;
        getShipperList(this.listQuery).then(response => {
          resolve();
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    // 添加方法
    funcAdd() {
      this.$router.push({
        path: "/shipment/addShipment",
        query: { company: "1", type: "add" }
      });
    },
    // 修改方法
    funcEdit(row) {
      this.$router.push({
        path: "/shipment/edit",
        query: {
          code: row.code,
          partyCode: row.partyCode,
          company: "1",
          branchCode: row.branchCode
        }
      });
    },
    // 设置必填项
    funcheckQuire(row) {
      this.$router.push({
        path: "/shipment/requiredShipmentCompanyForm",
        query: { company: "1", checkQuire: true }
      });
    },
    showShipmentMore(row) {
      return (
        this.getLimit("shipmentCompany_delete_button") ||
        (this.getLimit("shipmentCompany_DIS_button") &&
          this.showApplyDisBtn(row)) ||
        (row.authStatus == 3 &&
          !row.memNum &&
          this.getLimit("shipmentCompany_xvni_button")) ||
        (row.branchCode === "lbb03" &&
          this.getLimit("shipmentCompany_alipay_button") &&
          !row.alipayAccount) ||
        (row.authStatus === 3 &&
          this.getLimit("shipmentCompany_qiehuan_button")) ||
        (row.authStatus === 3 &&
          this.getLimit("shipmentCompany_fenpei_button")) ||
        this.getLimit("shipmentCompany_replacemanager_button")
      );
    },
    // 详情
    funcDetail(row) {
      this.$router.push({
        path: "/shipment/shipmentdetail",
        query: {
          code: row.code,
          partyCode: row.partyCode,
          company: "1",
          branchCode: row.branchCode
        }
      });
    },
    // 删除方法
    funcDelete(codes) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          delShipperInfo({ codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 申请DIS
    async funcApply(codes) {
      let response = await maYiBlockChain(codes);
      this.$message({ message: response.msg, type: "success" });
      this.findList();
    },
    // 创建虚拟账号方法
    funcDobiz(codes) {
      this.$confirm("确认需要创建光大虚拟账号吗？")
        .then(_ => {
          syncMemName({ code: codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    funAlipay(code) {
      this.$confirm("确认需要创建支付宝账号吗？")
        .then(_ => {
          syncFreightSubaccount({ code: code }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    formatterAlipayAccount({ cellValue }) {
      return cellValue || "--";
    },
    // 翻译审核状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusList.find(item1 => item1.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译通用是否状态
    formatterCommonStatus({ cellValue }) {
      const item = this.commonStatusList.find(
        item1 => item1.value === cellValue
      );
      return item ? item.label : "";
    },
    //提示标红
    cellClassName({ row, rowIndex, column, columnIndex }) {
      //身份证
      if (column.property === "idCardDueDate") {
        if (row.idcardDueWarn == 1) {
          return "col-red";
        }
      }
    },
    // 合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "amount") {
            return this.$XEUtils.sum(data, column.property);
          }
          /*          if (column.property === "ensureFee") {
              return "待定";
            }*/
          if (column.property === "ensureFeeAmount") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    }
  }
};
</script>
<style lang="scss" scoped>
.rotate90 {
  transform: rotate(90deg);
}
.shipment-switch {
  display: inline-block;
  transform: translateY(3px); /* 可根据需要调整偏移量 */
  margin-left: 15px;
  cursor: pointer;
}
.shipment_op {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.shipment_op ::v-deep .el-dropdown {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  line-height: 1;
}
.shipment_more_trigger {
  display: inline-flex;
  align-items: center;
  margin-left: 15px;
  color: #409eff;
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
}
</style>
